export const toggleMode = () => async (dispatch) => {
    dispatch({ type: "TOGGLE_MODE" });
}